var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStoreAndroid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 0h70a6 6 0 0 1 6 6v68a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z",
    id: "jhlvq3nnra"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dgbyoy6bnb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jhlvq3nnra"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#282828",
    d: "M76 .5c1.519 0 2.894.616 3.89 1.61A5.483 5.483 0 0 1 81.5 6v68a5.483 5.483 0 0 1-1.61 3.89A5.483 5.483 0 0 1 76 79.5H6a5.483 5.483 0 0 1-3.89-1.61A5.483 5.483 0 0 1 .5 74V6c0-1.519.616-2.894 1.61-3.89A5.483 5.483 0 0 1 6 .5z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#dgbyoy6bnb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.87 29.972 50.254 34.4l-6.444-6.412 6.374-6.43 7.686 4.47c1.507.875 1.507 3.066 0 3.942v.002z",
    fill: "#FED400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.254 34.4 27.392 47.692a2.242 2.242 0 0 1-2.745-.378L43.81 27.988l6.444 6.412z",
    fill: "#F83345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.81 27.99 24.647 47.316A2.25 2.25 0 0 1 24 45.722V10.28c0-.577.205-1.081.532-1.468l19.278 19.18v-.002z",
    fill: "#00D7FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.184 21.56-6.374 6.43L24.532 8.81c.667-.789 1.847-1.09 2.859-.503l22.791 13.254h.002z",
    fill: "#00EF77"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    mask: "url(#dgbyoy6bnb)",
    d: "M0 56h82v24H0z"
  }), /*#__PURE__*/React.createElement("text", {
    mask: "url(#dgbyoy6bnb)",
    fontFamily: "Roboto, Helvetica, sans-serif",
    fontSize: 14,
    wordSpacing: -0.2,
    letterSpacing: -0.2,
    fontWeight: 400,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 3.8,
    y: 73
  }, "Google Play")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreAndroid);
export default __webpack_public_path__ + "static/media/play_store_android.d734895c2a95061c6b7197376cb122e6.svg";
export { ForwardRef as ReactComponent };